import { render, staticRenderFns } from "./box6.vue?vue&type=template&id=624bfd1e&scoped=true&"
import script from "./box6.vue?vue&type=script&lang=js&"
export * from "./box6.vue?vue&type=script&lang=js&"
import style0 from "./box6.vue?vue&type=style&index=0&id=624bfd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624bfd1e",
  null
  
)

export default component.exports